import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2021-07-08'
        tag='Poshmark Snippets'
        title='How to Cancel an Order on Poshmark'
      >
        <p>
          If you haven't shipped an item yet, it's still possible to cancel an order before it's sent out! Here's how to
          do it:
        </p>
        <h3>On Desktop / Laptop</h3>
        <ol>
          <li>Click on your profile picture at the top right </li>
          <li>Click on "My Sales"</li>
          <li>Select the order you want to cancel</li>
          <li>Click on "Problems/Order Inquiry"</li>
          <li>Click on "Cancel Order"</li>
          <li>Select a reason for the cancellation then hit submit</li>
        </ol>
        <h3>In the Poshmark App:</h3>
        <ol>
          <li>Go to your accounts page(@account_name). It should be on the bottom right</li>
          <li>Scroll down to "My Sales"</li>
          <li>Select the order you wish to cancel</li>
          <li>Select Problems/Order Inquiry</li>
          <li>Select Cancel Order and enter in a reason for the cancellation</li>
        </ol>
        <p> Best of luck, and happy selling!</p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
